import React from "react";

function AfterCare()
{
    return(
        <div className="aftercare-container">
            <div className="aftercare-page-heading">
                <h1 style={{fontWeight:'bold', fontSize:'1.5rem'}}>Tattoo Aftercare Instructions (Second Skin Method)</h1>
                <h2>Thank you for trusting me with your tattoo. Proper aftercare is essential to ensure the best healing and color retention. Please follow these instructions carefully.</h2>
            </div>

<div className="aftercare-container-text-box">
    <div className="aftercare-container-heading">Initial Bandage (Second Skin)</div>
    <div className="aftercare-container-text">
        <ul>
            <li>Your tattoo has been covered with a protective adhesive film that acts as a “second skin.</li>
            <li>Keep it on for 1-4 days (no more than 4, as long as it’s sealed and not cause allergic reactions), depending on the amount of fluid build-up under the bandage.</li>
            <li>Small amounts of plasma or ink inside are normal.</li>
            <li>If the bandage fills with excessive fluid or starts to leak, remove it and switch to washing and ointment </li>
            <li> Bandage is water resistant, but not water proof, it’s ok shower with it, but avoid submerged it (avoid lakes, pools, saunas, hot yoga etc)</li>
        </ul>
    </div>
</div>

<div className="aftercare-container-text-box">
    <div className="aftercare-container-heading">Removing the Bandage</div>
    <div className="aftercare-container-text">
        <ul>
            <li>Wash your hands thoroughly.</li>
            <li>Remove the bandage slowly under warm running water.</li>
            <li>Once removed, wash the tattoo gently with lukewarm water and a mild, fragrance-free antibacterial soap.</li>
            <li>Pat dry with a clean paper towel or let it air dry — do not rub.</li>
            <li>Apply a small amount of ointment </li>
        </ul>
    </div>
</div>

<div className="aftercare-container-text-box">
    <div className="aftercare-container-heading">Healing Phase (After Bandage Removal)</div>
    <div className="aftercare-container-text">
        <ul>
            <li>For the next 7–14 days, keep your tattoo clean and lightly moisturized</li>
            <li>Wash your tattoo gently twice a day and apply a thin layer of fragrance-free tattoo ointment or lotion (Aquaphor, Hustle Butter, or a similar product) 2 times per day (morning/evening)</li>
            <li>Do not over-moisturize — the skin should feel soft, not greasy.</li>
            <li>Avoid scratching, peeling, or picking at any scabs or flakes.</li>
        </ul>
    </div>
</div>

<div className="aftercare-container-text-box">
    <div className="aftercare-container-heading">What to Avoid During Healing</div>
    <div className="aftercare-container-text">
        <ul>
            <li>No soaking: Avoid swimming, hot tubs, saunas, or long baths for at least 2 weeks.</li>
            <li>Avoid direct sunlight and tanning beds until fully healed.</li>
            <li>Overall avoid any situations where you can possibly get infected, be mindful in social places </li>
            <li>Don’t apply alcohol or scented lotions.</li>
            <li>Don’t wear tight clothing that may rub against the tattoo.</li>
        </ul>
    </div>
</div>

<div className="aftercare-container-text-box">
    <div className="aftercare-container-heading">Long-Term Care</div>
    <div className="aftercare-container-text">
        <ul>
            <li>Once healed, always use sunscreen (SPF 50+) on your tattoo to protect it from fading and wear UV sleeves for occasions where you exposed to sun all day (biking, hiking)</li>
            <li>Keep your skin hydrated and healthy — your tattoo will stay vibrant for years.</li>
        </ul>
    </div>
</div>
<p><span style={{fontWeight:'bold'}}>Healing time:</span>2 - 4 week on avaerage</p>
        </div>
    )
}

export default AfterCare;